import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import styles from './SchoolProjectDetail.module.css';

interface Project {
  id: string;
  month: string;
  rocnik: string | null;
  title: string;
  description: string;
  image: string | null;
  created_at: string;
}


export const SchoolProjectDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const guardRef = useRef(false);
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (guardRef.current) return;
    guardRef.current = true;

    const loadProject = async () => {
      if (!id) {
        setError('Projekt nebyl nalezen.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const { data, error: fetchError } = await supabase
          .from('school_portfolio_entries')
          .select('*')
          .eq('id', id)
          .single();

        if (fetchError) {
          setError('Projekt se nepodařilo načíst.');
          setProject(null);
        } else {
          setProject(data as Project);
        }
      } catch (err) {
        console.error(err);
        setError('Neočekávaná chyba při načítání projektu.');
      } finally {
        setLoading(false);
      }
    };

    loadProject();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className={styles.container}>
        <p className={styles.muted}>Načítám projekt...</p>
      </div>
    );
  }

  if (error || !project) {
    return (
      <div className={styles.container}>
        <Link to="/school-portfolio" className={styles.backLink}>
          ← Zpět na portfolio
        </Link>
        <div className={styles.errorBox}>{error || 'Projekt nebyl nalezen.'}</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Link to="/school-portfolio" className={styles.backLink}>
        ← Zpět na portfolio
      </Link>

      <div className={styles.header}>
        <div className={styles.badges}>
          <span className={styles.badge}>{project.month}</span>
          {project.rocnik && <span className={styles.badge}>{project.rocnik} ročník</span>}
        </div>
        <h1 className={styles.title}>{project.title}</h1>
      </div>

      <div className={styles.content}>
        <p className={styles.description}>{project.description}</p>
      </div>

      {project.image && (
        <div className={styles.cover}>
          <img src={project.image} alt={project.title} />
        </div>
      )}
    </div>
  );
};
